import { Tooltip, Typography, TypographyProps } from '@mui/material';

interface TruncatedTextWithTooltipFieldProps {
  text: string;
  maxWidth?: number;
  typographyProps?: TypographyProps;
}

/**
 * Displays text with truncation and tooltip when text exceeds maxWidth.
 * Useful for displaying long comma-separated lists in table cells.
 */
const TruncatedTextWithTooltipField = ({
  text,
  maxWidth = 200,
  typographyProps,
}: TruncatedTextWithTooltipFieldProps) => (
  <Tooltip title={text} arrow>
    <Typography
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: `${maxWidth}px`,
      }}
      {...typographyProps}
    >
      {text}
    </Typography>
  </Tooltip>
);

export default TruncatedTextWithTooltipField;
